import { HistoryCard } from "../HistoryCard";
import { HistoryCardPosition, HistoryWrapper } from "./style";

export const History = ({ history = [], oncCardClick }) => {
  return (
    <HistoryWrapper>
      {history.map((node, index) => (
        <HistoryCardPosition index={index} key={index} toRemove={node.toRemove}>
          <HistoryCard
            {...{
              title: node.title,
              content: node.body,
              onClick: () => oncCardClick(node, index),
              last: index === history.length - 1,
              slideOut: node.toRemove,
            }}
          />
        </HistoryCardPosition>
      ))}
    </HistoryWrapper>
  );
};
